export default __webpack_public_path__ + "static/media/attachments.59feb8c2.yaml";